import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'workflow-article-state',
    template: `
    <span class="label label-default" [ngClass]="'article-state-' + articleState">
      <i class="fa fa-circle"></i>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowArticleStateComponent {
  @Input() articleState: string;
}
